// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

import {Id} from './id.js'
import {SeqId} from './seq-id.js'

export class RemoveChar {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): RemoveChar {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  static getRootAsRemoveChar(bb: flatbuffers.ByteBuffer, obj?: RemoveChar): RemoveChar {
    return (obj || new RemoveChar()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  static getSizePrefixedRootAsRemoveChar(bb: flatbuffers.ByteBuffer, obj?: RemoveChar): RemoveChar {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH)
    return (obj || new RemoveChar()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  location(obj?: SeqId): SeqId | null {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset ? (obj || new SeqId()).__init(this.bb_pos + offset, this.bb!) : null
  }

  textField(obj?: Id): Id | null {
    const offset = this.bb!.__offset(this.bb_pos, 6)
    return offset ? (obj || new Id()).__init(this.bb_pos + offset, this.bb!) : null
  }

  static startRemoveChar(builder: flatbuffers.Builder) {
    builder.startObject(2)
  }

  static addLocation(builder: flatbuffers.Builder, locationOffset: flatbuffers.Offset) {
    builder.addFieldStruct(0, locationOffset, 0)
  }

  static addTextField(builder: flatbuffers.Builder, textFieldOffset: flatbuffers.Offset) {
    builder.addFieldStruct(1, textFieldOffset, 0)
  }

  static endRemoveChar(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject()
    builder.requiredField(offset, 4) // location
    return offset
  }
}
